import { render, staticRenderFns } from "./BoasVindas.vue?vue&type=template&id=4e391dbd&scoped=true&"
import script from "./BoasVindas.vue?vue&type=script&lang=js&"
export * from "./BoasVindas.vue?vue&type=script&lang=js&"
import style0 from "./boas-vindas.css?vue&type=style&index=0&id=4e391dbd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e391dbd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAvatar,VBtn,VCardText,VFlex,VIcon,VTextField,VTextarea})
